export default {
    // baseURL: "localhost:8000/apitest/public/",
    baseURL: "?z=ZhSaMNJDvmIlQCtYqurMDSpsmxhy1qlt",
}